{
  "title": "คำอธิบายระดับ",
  "label": "VIP",
  "levelLabel": "VIP {{level}}",
  "levelChangeConditions": "เงื่อนไขการเปลี่ยนระดับ",
  "levelChangeHint": "ทำตามเงื่อนไขการเลื่อนระดับ A หรือ B เพื่อเลื่อนระดับ หากไม่ผ่านเงื่อนไขรักษาระดับ A หรือ B จะถูกลดระดับในรอบถัดไป",
  "compareBenefits": "เปรียบเทียบสิทธิประโยชน์ของระดับ",
  "vipLevel": "ระดับ VIP",
  "sellOrderLevelCondition": "เงื่อนไขระดับคำสั่งขาย",
  "or": "หรือ",
  "exchangeLevelCondition": "เงื่อนไขระดับการแลกเปลี่ยน ({{token}})",
  "maintainNext": "รักษา V{{level}} ในรอบถัดไป",
  "promote": "เลื่อนเป็น V{{level}}",
  "demoteNext": "ลดเป็น V{{level}} ในรอบถัดไป",
  "maintain": "รักษา V{{level}}",
  "maintainLevel": "รักษาระดับ",
  "upgrade": "เลื่อนระดับ",
  "conditionA": "เงื่อนไข {{action}} A",
  "conditionB": "เงื่อนไข {{action}} B",
  "currentPeriodSellOrderCount": "จำนวนคำสั่งขายในรอบนี้",
  "currentPeriodSellOrderCountTarget": "จำนวนคำสั่งขายในรอบนี้ถึง",
  "currentPeriodSellOrderAmount": "ปริมาณคำสั่งขายในรอบนี้ ({{token}})",
  "currentPeriodSellOrderAmountTarget": "ปริมาณคำสั่งขายในรอบนี้ ({{token}}) ถึง",
  "currentPeriodExchangeAmount": "ปริมาณการแลกเปลี่ยนในรอบนี้ ({{token}})",
  "currentPeriodExchangeAmountTarget": "ปริมาณการแลกเปลี่ยนในรอบนี้ ({{token}}) ถึง",
  "countOnly": "ถึง {{count}} รายการ",
  "amountOnly": "จำนวนเงินถึง {{amount}}",
  "countAndAmount": "ถึง {{count}} รายการ\nและปริมาณถึง {{amount}} {{token}}"
}
